export default __webpack_public_path__ + "static/printable_placeholder-7a5cd9ba87a13bec8ea1843eaf3963b4.png";